<template>
  <v-chip :color="color" :outlined="outlined">{{ status }}</v-chip>
</template>

<script>
export default {
  name: "status-label",

  props: {
    value: {
      type: String,
      default: () => "",
    },
    outlined: {
      type: Boolean,
      default: () => true,
    },
  },
  computed: {
    status() {
      return this.params ? this.params.data.bookingStatus : this.value;
    },
    color() {
      const map = {
        Quotation: "secondary",
        Confirmed: "success",
        Cancelled: "warning",
        "Cancelled with charge": "warning",
        Requested: "primary",
      };

      if (this.status) {
        return map[this.status] ? map[this.status] : "secondary";
      } else {
        return "secondary";
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/labels/StatusLabel.vue